export default __webpack_public_path__ + "static/media/gluon-logo.93ac00c5.svg";